import { StoreType } from "./constants";
import { INDEXEDDB_EVENT_COUNT_LIMIT, MAX_ATTEMPTS, MEMORYDB_EVENT_COUNT_LIMIT } from "./defaults";
import { ResilienceOptions } from "./types";

export const createOptionsWithDefaults = (options: ResilienceOptions, storeType: StoreType): Required<ResilienceOptions> => ({
  logger: options.logger || console,
  useMemory: options.useMemory || false,
  maxAttempts: options.maxAttempts || MAX_ATTEMPTS,
  // This is so that we can customise `maxEventLimit`, primarily for testing.
  maxEventLimit: options.maxEventLimit || (storeType === StoreType.INDEXEDDB ? INDEXEDDB_EVENT_COUNT_LIMIT : MEMORYDB_EVENT_COUNT_LIMIT)
});
